import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { TestsAdmin } from '@/features/staff-workspace/TestsAdmin';

export const Route = createFileRoute('/admin/tests')({
  component: AdminTestsPage,
});

function AdminTestsPage() {
  const allowed = useCan('content.admin');
  if (!allowed) {
    return <StaffOnly title="You cannot open tests" description="Ask an admin for staff access." />;
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Tests"
        description="Every practice test and mock: how students do on it, a preview, and edits. An edit is saved as the next version and stays hidden until it is activated. Past attempts keep the version they took."
      />
      <TestsAdmin />
    </div>
  );
}
